import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import { string, func, bool } from 'prop-types';
import { useTranslation } from 'react-i18next';
const DateInput = ({
  autoComplete,
  birthDate,
  parentClass,
  handleInputBlur,
  handleInputChange,
  birthDateErr,
  accountInfoPage,
  ariaRequired = true
}) => {
  const [isHoverActive, setIsHoverActive] = useState(false);
  const { t } = useTranslation();

  const toggleTooltip = e => {
    if (e.key === 'Enter' || e.key === ' ')
      document.getElementById('dob-tooltip').classList.add('visibleTooltip');
    else
      document.getElementById('dob-tooltip').classList.remove('visibleTooltip');
  };

  const renderCommonBlock = t => {
    return (
      <div onMouseLeave={() => setIsHoverActive(false)}>
        <span
          tabIndex={0}
          onKeyDown={toggleTooltip}
          onBlur={toggleTooltip}
          onMouseEnter={() => setIsHoverActive(true)}
          className="dob-info d-inline-block dialogComponent"
          aria-describedby="dob-tooltip"
          role="tooltip"
        >
          {t('i')}
        </span>
        <div
          className={`show-tooltip ${isHoverActive ? 'visibleTooltip' : ''}`}
          id="dob-tooltip"
          onMouseEnter={() => setIsHoverActive(true)}
          onMouseLeave={() => setIsHoverActive(false)}
        >
          <p>
            {t(
              "Your date of birth helps us match our records with the pharmacy's. SingleCare will never sell your data to a third party."
            )}
          </p>
          <span></span>
        </div>
      </div>
    );
  };
  return (
    <div className={`${parentClass} form-group`}>
      {accountInfoPage ? (
        <h3 id="dob-Field">
          {t('Date of Birth')}
          {renderCommonBlock(t)}
        </h3>
      ) : (
        <label id="dob-Field">
          {t('Date of Birth')}
          {renderCommonBlock(t)}
        </label>
      )}
      <InputMask
        className={`sc-form__text sc-form__dob ${birthDateErr && 'invalid'}`}
        data-format="date"
        id="sc-form__dob"
        mask="99/99/9999"
        maskChar={'_'}
        type="text"
        name="birthDate"
        placeholder={t('MM/DD/YYYY')}
        value={birthDate}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        aria-labelledby="dob-Field"
        aria-required={ariaRequired}
        autoComplete={autoComplete}
        aria-invalid={birthDateErr ? 'true' : 'false'}
        aria-describedby="birthDateError"
      />
      <span id="birthDateError" className="label-error" role="alert">
        {t(birthDateErr)}
      </span>
    </div>
  );
};

DateInput.propTypes = {
  birthDate: string,
  handleInputBlur: func,
  handleInputChange: func,
  birthDateErr: string,
  parentClass: string,
  ariaRequired: bool,
  autoComplete: string,
  accountInfoPage: bool
};

export default DateInput;
